<template>
    <v-container fluid>
        <v-row>
            <v-col class="pl-5">
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-card flat>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="2">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="template_id"
                                    :ajax="true"
                                    :data="'document-checklists'"
                                    :label="$t('fields.loadFromTemplate')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    class="ml-2 mr-2 mt-1"
                                    color="primary"
                                    @click="loadFromTemplate()"
                                    :disabled="template_id == null"
                                >
                                    <v-icon class="mr-2" small>fas fa-paste</v-icon>{{ $t('buttons.load') }}
                                </v-btn>
                            </v-col>
                            <v-col class="text-right" v-if="updated != ''">
                                {{ $t('labels.checklistTemplateUpdatedOn') }} {{ updated }}</v-col
                            >
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 70vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-col cols="12">
                <v-row>
                    <v-col v-for="n in 3" cols="12" :key="n">
                        <MaritimeObjectDocumentChecklistPhase
                            :phase="n"
                            :documentChecklist="documentChecklist"
                            :inEditMode="inEditMode"
                            :key="componentKey"
                        ></MaritimeObjectDocumentChecklistPhase>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12">
                <v-card flat>
                    <v-card-text
                        ><v-row dense>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="1000"
                                    v-model="documentChecklist.additional_info"
                                    :label="$t('fields.additionalInformation')"
                                ></TextArea>
                            </v-col> </v-row></v-card-text
                ></v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import Dropdown from './trinkets/Dropdown';
import TextArea from '@/components/trinkets/TextArea';
import DocumentChecklist from '../models/DocumentChecklist';
import MaritimeObjectDocumentChecklistPhase from './MaritimeObjectDocumentChecklistPhase.vue';

export default {
    name: 'DocumentChecklist',
    components: {TextArea, Dropdown, MaritimeObjectDocumentChecklistPhase},
    data: function () {
        return {
            documentChecklist: new DocumentChecklist({}),
            documentChecklistValidation: new DocumentChecklist({}, true),
            initialLoad: false,
            lockKey: 'document-checklist',
            lockTimer: null,
            template_id: null,
            componentKey: 1,
            updated: '',
        };
    },
    props: ['maritimeObject', 'inEditMode'],
    emits: ['edit'],
    methods: {
        editClick() {
            this.$emit('edit');
        },

        backClick() {
            this.$router.go(-1);
        },

        loadFromTemplate() {
            let vm = this;
            this.$verify(this.$t('alerts.loadTemplate'), (result) => {
                if (result) {
                    let maritimeObjectId = this.maritimeObject.id;
                    this.$APICall(
                        'post',
                        'document-checklist-load/' + this.template_id,
                        {maritimeObjectId},
                        (data, success) => {
                            if (success) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                vm.documentChecklist = usableData.item;
                                vm.updated = usableData.updated;
                                vm.componentKey += 1;
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                    );
                }
            });
        },

        saveClick(goBack) {
            let vm = this;
            let action = 'post';
            let addition = '';
            if (vm.documentChecklist.id != 0) {
                action = 'put';
                addition = '/' + vm.documentChecklist.id;
            }
            this.$APICall(action, 'document-checklists' + addition, this.documentChecklist, (data, succes) => {
                if (succes) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    if (vm.documentChecklist.id != 0) {
                        vm.$alert(vm.$t('alerts.basicUpdate'));
                    } else {
                        vm.$alert(vm.$t('alerts.basicAdd'));
                    }
                    vm.documentChecklist = usableData.document_checklist;
                    this.updated = usableData.updated;
                    vm.$triggerReload();
                    vm.$emit('edit');
                    if (goBack) {
                        vm.backClick();
                    }
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        this.$APICall('get', 'document-checklists/' + this.maritimeObject.id, {}, (data, success) => {
            if (success) {
                let usableData = JSON.parse(JSON.stringify(data));
                vm.documentChecklist = usableData.item;
                vm.updated = usableData.updated;
                vm.componentKey += 1;
                if (vm.documentChecklist.id == 0) {
                    // vm.inEditMode = true;
                    vm.initialLoad = true;
                    vm.documentChecklist.maritime_object_id = vm.maritimeObject.id;
                } else {
                    vm.initialLoad = false;
                }
            } else {
                // vm.inEditMode = true;
                vm.initialLoad = true;
                vm.documentChecklist.maritime_object_id = vm.maritimeObject.id;
            }
        });
    },
};
</script>

<style scoped></style>
